export const innerConStyle = {
  width: "200px",
};
